import React, { useCallback, useContext } from 'react';

import { Animated } from '../../../../../Animated';
import { context } from '../../../../../Theme/Context';
import cn from 'utils/cn';

type TProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  className?: string;
  isCircle?: boolean;
};

function BentoMenuButton({ isOpen = false, setIsOpen, className = '', isCircle = true }: TProps) {
  const theme = useContext(context);

  const makeGrid = useCallback(() => {
    let count = 0;
    let grid = [];
    while (count < 9) {
      grid.push(
        <div
          key={'gridCircle' + count}
          style={{
            height: 4,
            width: 4,
            backgroundColor: theme.colors.foreground,
          }}
          className={'tw:rounded-full tw:bg-primary-100'}
        ></div>
      );
      count++;
    }
    return grid;
  }, [theme.colors.foreground]);

  return (
    <button
      data-testid="bento-menu-btn"
      type="button"
      className={cn(
        'tw:cursor-pointer tw:h-10 tw:w-10 tw:bg-brand-300 tw:hover:bg-brand-500 tw:flex tw:items-center tw:justify-center tw:border-0 z-1',
        className,
        isCircle && !isOpen && 'tw:rounded-full'
      )}
      style={{
        backgroundColor: theme.colors.background,
        color: theme.colors.foreground,
      }}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Animated
        animationIn="zoomIn"
        animationOut="zoomOut"
        animationInDuration={300}
        animationOutDuration={300}
        isVisible
        animateOnMount
        className={''}
        style={{
          width: 20,
          height: 20,
          display: 'grid',
          gridGap: 1,
          gridTemplateColumns: 'repeat(3, 1fr)',
          gridTemplateRows: 'repeat(3, 1fr)',
        }}
        onClick={undefined}
        innerRef={undefined}
      >
        {makeGrid()}
      </Animated>
    </button>
  );
}
export default BentoMenuButton;
